<template>
  <section class="sidebar">
    <div class="logotype">
      <button class="btn" v-if="false" @click="createGameSettings">GS</button>
      <button class="btn" v-if="false" @click="createGeneralDirectory">GD</button>
      <button class="btn" v-if="false" @click="createGeneralSettings">GS</button>
      <svg width="129" height="92" viewBox="0 0 129 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M64.7435 34.2939C59.6251 37.8633 56.7167 33.8153 53.074 36.0027C50.3514 37.6376 50.1666 51.0489 42.7821 60.3017C35.3976 69.5544 12.7572 64.065 9.93183 52.8301C8.23384 46.0781 9.91432 32.8604 19.9391 25.8694C28.1824 20.1207 39.8803 23.4688 42.7625 24.0107C46.2275 24.6622 43.7722 17.5353 50.0186 13.1792C56.0406 8.97963 64.2187 10.3019 68.2848 16.1325C72.351 21.9632 71.2808 29.7349 64.7435 34.2939Z" fill="url(#paint0_linear)"/>
      <path d="M61.0451 86.5435C68.2563 95.9058 85.261 87.6442 85.6393 80.4647C86.6964 60.4058 110.766 65.1277 109.645 55.433C108.688 47.158 97.0309 44.7688 91.4008 46.8527C77.6881 51.9284 90.6571 71.8722 73.3842 69.4739C65.5962 68.3925 53.834 77.1813 61.0451 86.5435Z" fill="url(#paint1_linear)"/>
      <circle cx="111.313" cy="37.124" r="2.85877" transform="rotate(30 111.313 37.124)" fill="url(#paint2_linear)"/>
      <path d="M35.2249 40.3294L37.4957 46.3633L39.7611 40.3294H41.5291V48.2015H40.1666V45.6063L40.3018 42.1352L37.9769 48.2015H36.9983L34.6788 42.1406L34.814 45.6063V48.2015H33.4515V40.3294H35.2249ZM45.6241 46.32L46.8136 42.3515H48.214L45.8891 49.0882C45.5322 50.0723 44.9267 50.5643 44.0724 50.5643C43.8814 50.5643 43.6705 50.5318 43.4398 50.467V49.4505L43.6885 49.4667C44.0202 49.4667 44.2689 49.4054 44.4347 49.2829C44.6041 49.1639 44.7374 48.9621 44.8348 48.6773L45.024 48.1745L42.9694 42.3515H44.386L45.6241 46.32ZM53.9581 43.9519C53.9581 44.2114 53.8788 44.4511 53.7202 44.671C53.5652 44.8872 53.3453 45.0602 53.0605 45.19C53.731 45.4243 54.0662 45.8767 54.0662 46.5471C54.0662 47.0842 53.8481 47.5131 53.412 47.8339C52.9758 48.1511 52.3919 48.3097 51.6602 48.3097C51.2132 48.3097 50.8059 48.2358 50.4383 48.088C50.0706 47.9366 49.7841 47.7239 49.5786 47.45C49.3732 47.1725 49.2704 46.8445 49.2704 46.466H50.5789C50.5789 46.7039 50.6852 46.9039 50.8979 47.0661C51.1105 47.2247 51.379 47.304 51.7035 47.304C52.0243 47.304 52.2784 47.2301 52.4658 47.0823C52.6568 46.931 52.7524 46.7345 52.7524 46.493C52.7524 46.2083 52.6695 46.0028 52.5036 45.8767C52.3378 45.7505 52.0819 45.6874 51.7359 45.6874H50.7951V44.7412H51.7683C52.3559 44.734 52.6496 44.4925 52.6496 44.0167C52.6496 43.7788 52.5649 43.5932 52.3955 43.4599C52.2261 43.3265 51.9936 43.2598 51.698 43.2598C51.4097 43.2598 51.1664 43.3319 50.9681 43.4761C50.7699 43.6166 50.6708 43.7951 50.6708 44.0113H49.3623C49.3623 43.4959 49.5786 43.0742 50.0112 42.7462C50.4437 42.4146 50.9934 42.2487 51.6602 42.2487C52.3847 42.2487 52.9488 42.3965 53.3525 42.6921C53.7562 42.9877 53.9581 43.4076 53.9581 43.9519ZM57.1502 44.2114H58.437C58.9164 44.2114 59.3345 44.2943 59.6913 44.4601C60.0482 44.6259 60.3185 44.8584 60.5023 45.1576C60.6898 45.4567 60.7835 45.8046 60.7835 46.2011C60.7835 46.803 60.5708 47.286 60.1455 47.6501C59.7202 48.0141 59.1543 48.1979 58.4478 48.2015H55.8363V42.3515H57.1502V44.2114ZM63.0705 48.2015H61.7567V42.3515H63.0705V48.2015ZM57.1502 45.2657V47.1526H58.4316C58.7524 47.1526 59.0047 47.0733 59.1885 46.9147C59.3759 46.7525 59.4697 46.5237 59.4697 46.2281C59.4697 45.9325 59.3777 45.7 59.1939 45.5306C59.0137 45.3576 58.7686 45.2693 58.4586 45.2657H57.1502ZM67.2791 45.8875H66.6141V48.2015H65.3003V42.3515H66.6141V44.6872H67.1926L68.8092 42.3515H70.4312L68.3172 45.1522L70.6096 48.2015H68.9011L67.2791 45.8875ZM75.3805 48.2015C75.3229 48.0898 75.2724 47.9078 75.2291 47.6555C74.811 48.0916 74.2992 48.3097 73.6936 48.3097C73.1061 48.3097 72.6267 48.1421 72.2555 47.8068C71.8842 47.4716 71.6986 47.0571 71.6986 46.5633C71.6986 45.9397 71.9292 45.4621 72.3906 45.1305C72.8556 44.7953 73.5188 44.6277 74.3803 44.6277H75.1859V44.2438C75.1859 43.941 75.1012 43.6995 74.9318 43.5193C74.7624 43.3355 74.5046 43.2436 74.1586 43.2436C73.8594 43.2436 73.6143 43.3193 73.4233 43.4707C73.2323 43.6184 73.1367 43.8077 73.1367 44.0384H71.8229C71.8229 43.7176 71.9292 43.4184 72.1419 43.1409C72.3546 42.8597 72.6429 42.6398 73.007 42.4812C73.3746 42.3226 73.7837 42.2433 74.2343 42.2433C74.9192 42.2433 75.4652 42.4164 75.8725 42.7624C76.2798 43.1048 76.4889 43.5878 76.4997 44.2114V46.8499C76.4997 47.3761 76.5736 47.796 76.7214 48.1096V48.2015H75.3805ZM73.9369 47.2554C74.1965 47.2554 74.4398 47.1923 74.6668 47.0661C74.8975 46.94 75.0705 46.7706 75.1859 46.5579V45.4549H74.4776C73.991 45.4549 73.6252 45.5396 73.38 45.709C73.1349 45.8785 73.0124 46.1182 73.0124 46.4281C73.0124 46.6804 73.0953 46.8823 73.2611 47.0337C73.4305 47.1815 73.6558 47.2554 73.9369 47.2554ZM83.4009 42.3515V48.2015H82.087V43.4112H80.4326L80.3244 45.4495C80.2559 46.4299 80.0667 47.1346 79.7567 47.5635C79.4503 47.9889 78.98 48.2015 78.3456 48.2015H77.9401L77.9347 47.1094L78.205 47.0823C78.4934 47.0427 78.7024 46.8679 78.8322 46.5579C78.9655 46.2443 79.0503 45.6748 79.0863 44.8494L79.1944 42.3515H83.4009ZM86.766 44.2114H88.0528C88.5322 44.2114 88.9503 44.2943 89.3071 44.4601C89.664 44.6259 89.9343 44.8584 90.1182 45.1576C90.3056 45.4567 90.3993 45.8046 90.3993 46.2011C90.3993 46.803 90.1866 47.286 89.7613 47.6501C89.336 48.0141 88.7701 48.1979 88.0636 48.2015H85.4522V42.3515H86.766V44.2114ZM86.766 45.2657V47.1526H88.0474C88.3682 47.1526 88.6205 47.0733 88.8043 46.9147C88.9918 46.7525 89.0855 46.5237 89.0855 46.2281C89.0855 45.9325 88.9936 45.7 88.8097 45.5306C88.6295 45.3576 88.3844 45.2693 88.0744 45.2657H86.766ZM96.9598 48.2015H95.646V45.8388H93.3698V48.2015H92.0559V42.3515H93.3698V44.7899H95.646V42.3515H96.9598V48.2015ZM100.33 44.2114H101.617C102.097 44.2114 102.515 44.2943 102.872 44.4601C103.228 44.6259 103.499 44.8584 103.683 45.1576C103.87 45.4567 103.964 45.8046 103.964 46.2011C103.964 46.803 103.751 47.286 103.326 47.6501C102.9 48.0141 102.334 48.1979 101.628 48.2015H99.0165V42.3515H100.33V44.2114ZM106.251 48.2015H104.937V42.3515H106.251V48.2015ZM100.33 45.2657V47.1526H101.612C101.933 47.1526 102.185 47.0733 102.369 46.9147C102.556 46.7525 102.65 46.5237 102.65 46.2281C102.65 45.9325 102.558 45.7 102.374 45.5306C102.194 45.3576 101.949 45.2693 101.639 45.2657H100.33ZM112.033 42.3515H113.341V48.2015H112.033V44.2979L109.74 48.2015H108.432V42.3515H109.74V46.2551L112.033 42.3515ZM57.1556 56.2976C56.8492 56.2976 56.5897 56.3932 56.377 56.5842C56.1644 56.7716 56.058 57.0077 56.058 57.2925H54.8199C54.8199 56.932 54.9244 56.595 55.1335 56.2814C55.3425 55.9642 55.6291 55.7119 55.9931 55.5245C56.3572 55.3371 56.7447 55.2433 57.1556 55.2433C57.9486 55.2433 58.5848 55.5155 59.0642 56.0598C59.5472 56.604 59.7887 57.3303 59.7887 58.2387V58.3738C59.7887 58.9325 59.6787 59.4389 59.4588 59.8931C59.2426 60.3473 58.9362 60.6969 58.5397 60.942C58.1432 61.1871 57.6836 61.3097 57.161 61.3097C56.7176 61.3097 56.3157 61.2178 55.9553 61.0339C55.5948 60.8465 55.3155 60.5852 55.1173 60.25C54.919 59.9147 54.8199 59.5363 54.8199 59.1145H56.058C56.058 59.4498 56.1644 59.7255 56.377 59.9418C56.5897 60.1544 56.851 60.2608 57.161 60.2608C57.5286 60.2608 57.826 60.1238 58.0531 59.8499C58.2802 59.5723 58.4153 59.1866 58.4586 58.6928H56.6203V57.7845H58.4532C58.4027 57.3087 58.264 56.9429 58.0369 56.6869C57.8098 56.4274 57.516 56.2976 57.1556 56.2976ZM66.5925 58.336C66.5925 59.2407 66.387 59.9634 65.9761 60.5041C65.5652 61.0411 65.0137 61.3097 64.3216 61.3097C63.68 61.3097 63.1664 61.0988 62.7807 60.6771V63.4507H61.4669V55.3515H62.678L62.7321 55.9462C63.1177 55.4776 63.6422 55.2433 64.3054 55.2433C65.0191 55.2433 65.5778 55.5101 65.9815 56.0435C66.3888 56.5734 66.5925 57.3105 66.5925 58.2549V58.336ZM65.284 58.2224C65.284 57.6385 65.1669 57.1753 64.9326 56.8329C64.7019 56.4905 64.3703 56.3193 63.9378 56.3193C63.4007 56.3193 63.015 56.541 62.7807 56.9843V59.5795C63.0186 60.0337 63.4079 60.2608 63.9486 60.2608C64.3667 60.2608 64.6929 60.0932 64.9272 59.7579C65.1651 59.4191 65.284 58.9073 65.284 58.2224ZM70.2442 59.32L71.4336 55.3515H72.834L70.5091 62.0882C70.1522 63.0723 69.5467 63.5643 68.6924 63.5643C68.5014 63.5643 68.2905 63.5318 68.0598 63.467V62.4505L68.3086 62.4667C68.6402 62.4667 68.8889 62.4054 69.0547 62.2829C69.2241 62.1639 69.3575 61.9621 69.4548 61.6773L69.644 61.1745L67.5895 55.3515H69.006L70.2442 59.32ZM73.8688 60.1526C74.2329 59.7453 74.4762 59.3597 74.5987 58.9956C74.7249 58.6279 74.8006 58.1594 74.8258 57.5899L74.9015 55.3515H78.9619V60.1526H79.7729V62.9425H78.4645V61.2015H74.7123V62.9425H73.3822L73.3876 60.1526H73.8688ZM75.4097 60.1526H77.6535V56.4815H76.1775L76.1396 57.6007C76.0892 58.6748 75.8459 59.5255 75.4097 60.1526ZM84.8196 55.3515H86.128V61.2015H84.8196V57.2979L82.5271 61.2015H81.2187V55.3515H82.5271V59.2551L84.8196 55.3515ZM92.6831 56.395H90.7853V61.2015H89.4715V56.395H87.5954V55.3515H92.6831V56.395Z" fill="#00325C"/>
      <defs>
      <linearGradient id="paint0_linear" x1="62.1669" y1="13.059" x2="22.753" y2="80.8816" gradientUnits="userSpaceOnUse">
      <stop stop-color="#E85AFF" stop-opacity="0.81"/>
      <stop offset="1" stop-color="#4791FF" stop-opacity="0.81"/>
      </linearGradient>
      <linearGradient id="paint1_linear" x1="87.1377" y1="87.3476" x2="75.0055" y2="33.7346" gradientUnits="userSpaceOnUse">
      <stop stop-color="#E85AFF" stop-opacity="0.81"/>
      <stop offset="1" stop-color="#4791FF" stop-opacity="0.81"/>
      </linearGradient>
      <linearGradient id="paint2_linear" x1="111.098" y1="34.4233" x2="115.182" y2="42.9127" gradientUnits="userSpaceOnUse">
      <stop stop-color="#E85AFF" stop-opacity="0.81"/>
      <stop offset="0.746285" stop-color="#4791FF" stop-opacity="0.81"/>
      </linearGradient>
      </defs>
      </svg>
    </div>
    <nav>
      <ul>
        <router-link tag="li" to="/">Перейти в игру</router-link>
        <router-link tag="li" to="/admin/">Каталог песен</router-link>
        <router-link tag="li" to="/admin/directory">Справочники</router-link>
        <router-link tag="li" to="/admin/settings">Настройки игры</router-link>
        <router-link tag="li" to="/admin/metrics">Метрики</router-link>
        <router-link tag="li" to="/admin/gamers">Игроки</router-link>
        <router-link tag="li" to="/admin/newsfeed">Новости</router-link>
        <router-link tag="li" to="/admin/stocks">Розыгрыши</router-link>
        <router-link tag="li" to="/admin/library">Фонотека</router-link>
        <router-link v-if="user.role === 1" tag="li" to="/admin/admins">Администраторы</router-link>
      </ul>
    </nav>
    <div class="profile" v-if="user">
      <div class="profile__actions">
        <div class="avatar">
          <img v-if="user.photo" :src="user.photo" alt="">
        </div>
        <div @click="showDrop">
          <svg :class="{active: drop}" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5.5 4.85714L10 1" stroke="#6461F6" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1 4.85718L5.5 8.71432L10 4.85718" stroke="#6461F6" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <transition name="fade">
          <div v-if="drop" class="drop">
            <ul>
              <li @click="profile">Личный кабинет</li>
              <li @click="logout">Выход</li>
            </ul>
          </div>
        </transition>
      </div>
      <div class="profile__info">
        <div class="name">{{ user.name || user.login }}</div>
        <div class="role">{{ user.role | roleFilter }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'Sidebar',
  data() {
    return {
      drop: false,
      user: this.$store.getters.user
    }
  },
  mounted() {

  },
  methods: {
    createGeneralSettings() {
      Axios
        .post(`/api/setting`, {}, {
          headers: {
            token: this.$store.getters.token
          }
        })
        .then(res => {
          
        })
        .catch(err => {
          console.error(err.response);
        })
    },
    createGeneralDirectory() {
      Axios
        .post(`/api/directory`, {}, {
          headers: {
            token: this.$store.getters.token
          }
        })
        .then(res => {
          
        })
        .catch(err => {
          console.error(err.response);
        })
    },
    createGameSettings() {
      Axios
        .post(`/api/game/settings`, {}, {
          headers: {
            token: this.$store.getters.token
          }
        })
        .then(res => {
          
        })
        .catch(err => {
          console.error(err.response);
        })
    },
    profile() {
      this.drop = false;
      this.$router.push('/admin/profile');
    },
    showDrop() {
      this.drop = !this.drop;
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push('/admin/auth');
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  flex-shrink: 0;
  flex-basis: 200px;
  max-width: 200px;
  height: 100%;
  box-shadow: 0px 0px 10px rgba(0, 50, 92, 0.1);
  background-color: #fff;
  border-radius: 0 25px 25px 0;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  .logotype {
    height: 220px;
    svg {
      width: 170px;
      height: 126px;
      position: relative;
      left: -10px;
      top: 20px;
    }
  }
  nav {
    flex-grow: 1;
    ul {
      li {
        text-transform: uppercase;
        color: #aab5d1;
        font-size: 14px;
        padding: 12px 0;
        font-weight: 600;
        transition: 0.3s all;
        cursor: pointer;
        &:hover {
          color: #6461F6;
          transition: 0.3s all;
        }
        &.router-link-exact-active {
          color: #6461F6;
          box-shadow: inset -3px 0 0 #6461F6;
        }
        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }
    }
  }
  .profile {
    height: 120px;
    &__actions {
      display: flex;
      align-items: center;
      position: relative;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: rgb(226, 226, 226);
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      svg {
        position: relative;
        top: 2px;
        width: 12px;
        height: 12px;
        cursor: pointer;
        margin-left: 10px;
      }
      .drop {
        position: absolute;
        top: 70%;
        width: 180px;
        left: 40px;
        background-color: #fff;
        box-shadow: 2px 2px 10px rgba(0, 50, 92, 0.1);
        border-radius: 10px;
        ul {
          li {
            padding: 10px;
            text-align: center;
            font-size: 14px;
            color: #00325C;
            font-weight: 500;
            cursor: pointer;
          }
        }
      }
    }
    &__info {
      font-weight: 500;
      margin-top: 10px;
      .name {
        color: #00325C;
        margin-bottom: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 90%;
      }
      .role {
        font-size: 13px;
        color: #B5B4D6;
      }
    }
  }
}
</style>